<div>
  <app-tank-volume-graphic
    [fillColor]="fillColor"
    [tankLevelPercent]="tankLevelPercent"
    [volumeSuffix]="volumeSuffix"
    [height]="height"
  ></app-tank-volume-graphic>
</div>
<ng-container *ngIf="showVolumeLevelLabels === true">
  <div role="tank-volume-value-list-container" fxFlex>
  <ul role="tank-volume-value-list">
    <li role="major-volume-line">
      <label
        >{{ tankCapacity | number }}
        {{ volumeSuffix }}</label
      >
    </li>
    <li role="minor-volume-line"></li>
    <li role="minor-volume-line"></li>
    <li role="major-volume-line">
      <label
        >{{ tankCapacity * 0.75 | number }}
        {{ volumeSuffix }}</label
      >
    </li>
    <li role="minor-volume-line"></li>
    <li role="minor-volume-line"></li>
    <li role="major-volume-line">
      <label
        >{{ tankCapacity * 0.25 | number }}
        {{ volumeSuffix }}</label
      >
    </li>
    <li role="minor-volume-line"></li>
    <li role="minor-volume-line"></li>
    <li role="major-volume-line">
      <label>0 {{ volumeSuffix }}</label>
    </li>
  </ul>
  </div>
</ng-container>
